<template>
    <div class="page page-kinkekaart2">
        <form @submit="checkForm">
            <p v-if="errors.length">
                <ul class="errors">
                    <li v-for="error in errors" :key="error">{{ error }}</li>
                </ul>
            </p>
            <input class="form-field" id="cardno" v-model="cardno" oncontextmenu="return false"  @click="focus('cardno')" autofocus data-translation-attributes="placeholder" data-translation-attribute-placeholder="sisu-kinkekaart2-cardno" placeholder="Kaardi number"/>
            <input class="form-field" id="valid" v-model="valid" oncontextmenu="return false" @click="focus('valid')" data-translation-attributes="placeholder" data-translation-attribute-placeholder="sisu-kinkekaart2-valid" placeholder="Kehtivusaeg"/>
            <button class="btn btn-active btn-lg" @click="checkForm" data-translation-element="sisu-kinkekaart2-button">Otsi</button>
        </form>
        <div id="keyboard-container" class="keyboard"></div>
        <div class="kinkekaart-card" :class="{'active': showCard}" @click="resetCard">
            <div class="kinkekaart-card-content drop-shadow">
                <div class="card-loading" v-show="loading">
                    <div class="spinner">
                        <div class="bounce1"></div>
                        <div class="bounce2"></div>
                        <div class="bounce3"></div>
                    </div>
                </div>
                <div class="card-value" v-show="!loading">
                    {{ value / 100 }} EUR
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import OSK from 'on-screen-js-keyboard';
import { mapState } from 'vuex';

/* eslint-disable no-useless-escape */
export default {
    data () {
        return {
            errors: [],
            cardno: "",
            valid: "",
            validRegex: /^([0-3][0-9])\.([0-1][0-9])\.(2\d\d\d)/,
            showCard: false,
            loading: true,
            value: 0
       }
    },
    computed: {
        ...mapState('wf', ['reset']),
    },
    mounted () {
		this.keyboard = new OSK('cardno', 'keyboard-container');
		this.keyboard.on('change', (input) => {
            if (this.keyboard.output.id == "cardno") {
                this.cardno = input;
            }
            else {
                this.valid = input;
            }
		});

        this.keyboard.addLayout('num', {
			"name": "Numeric",
			"keyboard":"Numeric",
			"local_name": "Numeric",
			"lang": "num",
			"keys": {
				"default": [
					["7", "8", "9", ],
					["4", "5", "6",],
					["1", "2", "3",],
					["0", ".", {'key': "&#171;", 'action': ["backspace"], cls: "delete"}]
					]
				}
		});
        this.keyboard.changeLayout('num');
    },
    watch: {
		reset () {
			this.resetCard();
		},
        valid () {
            console.log('valid watch', this.valid)
        }
	},
    methods: {
        focus (field) {
            console.log('focus', field);
            this.keyboard.setOutput(field);
        },
        resetCard: function () {
            this.showCard = false;
            this.value = 0;
            this.valid = "";
            this.cardno = "";
            this.errors = [];
        },
        checkForm: function (e) {
            e.preventDefault();
            this.errors = [];
            console.log('this.cardno.length', this.cardno.length, this.valid, this.valid.match(this.validRegex))
            if (this.cardno.length < 16) {
                this.errors.push(this.$wayfinder.translator.get("cardno-short"));
            }
            if (this.cardno.length > 16) {
                this.errors.push(this.$wayfinder.translator.get("cardno-long"));
            }

            if (!this.valid.match(this.validRegex)) {
                this.errors.push(this.$wayfinder.translator.get("valid-regex"));
            }

            if (!this.errors.length) {
                this.showCard = true;
            //reqs.push(axios.request('', {method: 'POST', data: body}));
                fetch('https://www.ulemiste.ee/wp-json/wf_giftcard/v1/balance', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
						'pan': this.cardno,
						'expdate': this.valid
					})
                    }).then((resp) => resp.json()).then(balance => {
                        if (balance && balance.respcode === "000") {
                            this.value = balance.balance;
                            this.loading = false;
                        }
                        else {
                            this.loading = false;
                            alert(balance.error);
                        }
                    });
            }

            return false;
        },
    }
}
</script>

<style lang="less">
    .page-kinkekaart2 {
        align-items: center;
        position: relative;

        form > * {
            margin-bottom: 0.8rem;
            display: flex;
            flex-direction: column;
            width: 30rem;
        }

        .errors {
            color: #FB4E4E;
            list-style-type: none;
            padding: 0;
            margin: 0.1rem;
            li {
                margin-bottom: 0.2rem;
            }
        }

        .kinkekaart-card {
            background-color: rgba(255, 255, 255, 0.0);
            width: 100%;
            top: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            overflow: hidden;
            bottom: 0;
            position: absolute;
            align-items: center;
            transition: top 0.3s ease-out, background-color 0.3s ease-out;
            padding-bottom: 6rem;

            &.active {
                top: 0;
                background-color: rgba(255, 255, 255, 0.7);
            }
        }

        .kinkekaart-card-content {
            width: 40rem;
            height: 23rem;
            position: absolute;
            background-color: #FAF9F8;
            font-size: 6rem;
            display: flex;
            justify-content: center;
            align-items: center;            
        }

        .btn {
            align-self: center;
            margin: 1.6rem 0;
            padding: 0.8rem 9rem;
            text-align: center;
            justify-content: center;
            font-weight: 500;
        }

        .keyboard {
            widows: 100%;
        }

        .keyboard-key2x {
            width: 8.4ch !important;
        }
    }
</style>